module.exports = __webpack_public_path__ + "static/media/bg.df4da3f5.png";